import { queryOptions } from '@tanstack/react-query';
import { minutesToMilliseconds } from 'date-fns';
import { Reg28ClientBreachesResponseModelMock } from 'modules/my-practice/types/regulation-28/regulation-28.interfaces';
import { mockReg28ClientExposureResponse } from 'stores/mockData';

export const clientBreachesKeys = {
  base: () => ['client-portfolio-exposure'] as const,
  getClients: () => ['client-portfolio-exposure'] as const
};

export const getClientsWithReg28Breaches = () => {
  return queryOptions({
    queryKey: clientBreachesKeys.getClients(),
    queryFn: async (): Promise<Reg28ClientBreachesResponseModelMock[]> => {
      const delay = (ms: number) => new Promise((res) => setTimeout(res, ms));
      await delay(3500);
      return mockReg28ClientExposureResponse;
    },
    staleTime: minutesToMilliseconds(5)
  });
};
